<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button type="primary" @click="exportAll" class="chaxun">导出</Button></template>
    </selectTool>
    <Echart ref="echart"></Echart>
    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(440)">
      <ul slot-scope="{ row, index }" slot="pickupAddress">
        <li style="margin-bottom: 10px;" v-for="(x, index) in row.pickupAddress2" :key='index'>
          <strong>{{ x.split('_')[0] }}</strong>
          <p>{{ x.split('_')[1] }}</p>
        </li>
      </ul>
      <ul slot-scope="{ row, index }" slot="unloadAddress">
        <li style="margin-bottom: 10px;" v-for="(x, index) in row.unloadAddress2" :key='index'>
          <strong>{{ x.split('_')[0] }}</strong>
          <p>{{ x.split('_')[1] }}</p>
        </li>
      </ul>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
  </div>
</template>

<script>
var kehuitems = [];
import Echart from "./echart.vue";
export default {
  components: {
    Echart
  },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "业务员",
          key: "saleman",
        },
        {
          title: "销售金额",
          key: "totalAmount",
        },
        {
          title: "销售订单数",
          key: "totalNum",
        },
       
        {
          title: "统计时间",
          key: "reportTime2",
        },

      ],
      tableData: [],

      searchItem: {
        "pageNumber": 1,
        "pageSize": 50,
        "startTime": "",
        "endTime": "",
        "cid": '',
        "carNo": "",
        "ono": "",
        "driver": ""
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "车牌号",
          key: "carNo",
          type: "Input",
        }, {
          title: "客户名称",
          key: "cid",
          type: "Select",
          selectType: 'obj',
          selectItems: kehuitems
        },
      ],
      total: 0,
      forms: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-rpt/profiReport/salemanOrdersReport",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          data[i].reportTime2 = this.utils.time(data[i].reportTime,'yymmdd');
        }

        this.tableData = data;
        this.toEchart(data);
      });
    },
    toEchart(data) {
      
      var v = [
        ["客户", "销售金额"],

      ]
      for (let i = 0; i < data.length; i++) {
        v.push([data[i].customer,data[i].totalAmount])
      }
      this.$refs.echart.reach(v)
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    exportAll() {
      this.$Message.info('暂无导出')
      return;
      var params = [
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort +
        "/cloud-tms-server-fms/accountsReceivable/driverSalaryExportExcel",
        params
      );
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    }
  },
  mounted() {
    this.kehuList();
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/report/yewuxiaoshou.vue